import React from 'react';

import { Button, TitleWithDescription, InfoBox } from '@infoods/lifebase-ui';
import { useToggle } from 'react-use';

import classes from './NgzRegistrationFormStyleWidget.module.scss';
import { UploadRegistrationLogoModal } from './UploadRegistrationLogoModal/UploadRegistrationLogoModal';
import { angularizeWithProviders } from '../../../../../shared/providers/angularizeWithProviders/angularizeWithProviders';

type NgzRegistrationFormStyleWidgetProps = {
  entityId: number;
};

const NgzRegistrationFormStyleWidget = ({
  entityId,
}: NgzRegistrationFormStyleWidgetProps) => {
  const [isQrCodeModalOpen, toggleQrCodeModalOpen] = useToggle(false);

  return (
    <>
      <InfoBox title="User Registration Form Style">
        <div className={classes.row}>
          <TitleWithDescription
            title="Company Logo"
            description="Feel free to incorporate your business logo alongside the SWYMO logo to showcase our partnership."
            titleFont="body-14-bold"
            className={classes.title}
          />
          <Button variant="outlined" size="small" onClick={toggleQrCodeModalOpen}>
            Upload logo
          </Button>
        </div>
      </InfoBox>
      {isQrCodeModalOpen && (
        <UploadRegistrationLogoModal
          entityId={entityId}
          onClose={toggleQrCodeModalOpen}
        />
      )}
    </>
  );
};

angularizeWithProviders(
  NgzRegistrationFormStyleWidget,
  'ngzRegistrationFormStyleWidget',
  { entityId: '<' },
);

export { NgzRegistrationFormStyleWidget };
